<template>
  <span>{{ formattedValue }}</span>
</template>

<script>
import TWEEN from "@tweenjs/tween.js";

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 800,
    },
    decimals: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      animatedNumber: this.value,
    };
  },
  computed: {
    formattedValue() {
      if (isNaN(this.animatedNumber)) return "0.0";
      return this.animatedNumber.toFixed(this.decimals);
    },
  },
  methods: {
    initAnimation(newValue, oldValue) {
      const vm = this;

      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }

      new TWEEN.Tween({ tweeningNumber: oldValue })
        .easing(TWEEN.Easing.Quadratic.Out)
        .to({ tweeningNumber: newValue }, this.duration)
        .onUpdate(function (object) {
          vm.animatedNumber = object.tweeningNumber;
        })
        .start();

      animate();
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.initAnimation(newValue, oldValue);
    },
  },
  mounted() {
    this.animatedNumber = this.value;
  },
};
</script>
